import 'reflect-metadata';

import { injectable } from 'inversify';
import React from 'react';
import { IntersectionOptions } from 'react-intersection-observer';

import {
  withAnyOfPermissions,
  withIntersectionObserver,
  withLoadingStatus,
} from '../../core/infrastructrue/hoc';
import { withManifestUIToaster } from '../../core/infrastructrue/hoc/withManifestUIToaster';
import {
  IWithLoadingStatusHOCOptions,
  TAnyOfPermissionsHOC,
  TFunctionComponent,
} from '../../core/infrastructrue/types';

@injectable()
export abstract class ReactComponent {
  protected static withAnyOfPermissionsHOC<T>(
    permissionsToCheck: Array<string>,
    ReactComponent: React.FC<T>,
    ReactComponentProps: React.PropsWithChildren<TAnyOfPermissionsHOC<T>>,
  ): React.ReactElement<T> {
    return withAnyOfPermissions(
      permissionsToCheck,
      ReactComponent,
    )(ReactComponentProps);
  }

  protected static composeWithIntersectionObserver<T>(
    ReactComponent: React.FC<T>,
    intersectionObserverOptions: IntersectionOptions,
  ): TFunctionComponent<T> {
    return withIntersectionObserver<T>(
      ReactComponent,
      intersectionObserverOptions,
    );
  }

  protected static composeWithLoadingStatus<T>(
    ReactComponent: React.FC<T>,
    options?: Pick<IWithLoadingStatusHOCOptions, 'withLoadingStatusOptions'>,
  ): TFunctionComponent<T> {
    return withLoadingStatus<T>(ReactComponent, options);
  }

  protected static composeWithManifestUIToaster<T>(
    ReactComponent: React.FC<T>,
  ): TFunctionComponent<T> {
    return withManifestUIToaster<T>(ReactComponent);
  }
}
